import { useEffect, useRef } from "react";
import fsClient from "../data/firestoreClient";

// One mutation per business, with independent updates for other favorites.
export default function useFavoriteActions({ uid, favorites, onChange, onError, onLogin, db }) {
  const current = useRef(null);
  const pending = useRef(new Map());
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  current.current = { uid, favorites };
  return async (value) => {
    const id = String(value || "").trim();
    if (!uid) { onLogin?.(); return; }
    if (!id) return;
    const key = `${uid}/${id}`;
    if (pending.current.has(key)) return;
    const before = current.current.favorites.has(id);
    const change = (added) => onChange((previous) => {
      const next = new Set(previous);
      if (added) next.add(id); else next.delete(id);
      return next;
    });
    pending.current.set(key, true);
    change(!before);
    try {
      await fsClient.setFavorite(uid, id, !before, { db });
    } catch (error) {
      if (mounted.current && current.current.uid === uid) {
        change(before);
        onError?.(error);
      }
    } finally {
      pending.current.delete(key);
    }
  };
}
